class DelegatedCardRequestCounterController {

  $onInit() {
    this.monthsEmptyCounter = this._getMonthsEmptyCounter();
  }

  hasMonthEmpty() {
    const EMPTY_COUNTER_EMPTY = '00';
    return this.monthsEmptyCounter !== EMPTY_COUNTER_EMPTY;
  }

  _getMonthsEmptyCounter() {
    let counter = 0;
    this.cards.forEach((card) => {
      if(card.state === '') counter++;
    });
    return this._formatCounter(counter);
  }

  _formatCounter(counterNumber) {
    return '0' + counterNumber;
  }

}

export default DelegatedCardRequestCounterController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardRequestCounter/delegatedCardRequestCounter.controller.js